import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-navy-900">
        <Loader2 className="h-8 w-8 animate-spin text-amber-500" aria-hidden="true" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
